import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e5ebe42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 gap-4 w-1/2 mb-5" }
const _hoisted_2 = { class: "text-grey mb-4" }
const _hoisted_3 = { class: "gridTooltipButton tooltip infoIcon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-info" }, null, -1))
const _hoisted_5 = { class: "tooltiptext shadow" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputField flex-grow" }
const _hoisted_9 = { class: "error-msg" }
const _hoisted_10 = { class: "inputTitle" }
const _hoisted_11 = { class: "inputField flex-grow" }
const _hoisted_12 = { class: "inputTitle" }
const _hoisted_13 = { class: "inputField flex-grow" }
const _hoisted_14 = { class: "inputTitle" }
const _hoisted_15 = { class: "inputField flex-grow" }
const _hoisted_16 = { class: "text-grey mb-4" }
const _hoisted_17 = { class: "gridTooltipButton tooltip infoIcon" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-info" }, null, -1))
const _hoisted_19 = { class: "tooltiptext shadow" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "inputTitle" }
const _hoisted_22 = { class: "inputField flex-grow" }
const _hoisted_23 = { class: "inputTitle" }
const _hoisted_24 = { class: "inputField flex-grow" }
const _hoisted_25 = { class: "text-grey mb-4" }
const _hoisted_26 = { class: "gridTooltipButton tooltip infoIcon" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-info" }, null, -1))
const _hoisted_28 = { class: "tooltiptext shadow" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { class: "inputTitle" }
const _hoisted_31 = { class: "inputField flex-grow" }
const _hoisted_32 = { class: "inputTitle" }
const _hoisted_33 = { class: "inputField flex-grow" }
const _hoisted_34 = { class: "error-msg" }
const _hoisted_35 = { class: "inputTitle" }
const _hoisted_36 = { class: "inputField flex-grow" }
const _hoisted_37 = { class: "inputTitle" }
const _hoisted_38 = { class: "inputField flex-grow" }
const _hoisted_39 = { class: "inputTitle" }
const _hoisted_40 = { class: "inputField flex-grow" }
const _hoisted_41 = { class: "text-grey mb-4" }
const _hoisted_42 = { class: "gridTooltipButton tooltip infoIcon" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-info" }, null, -1))
const _hoisted_44 = { class: "tooltiptext shadow" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = { class: "inputTitle" }
const _hoisted_47 = { class: "inputField flex-grow" }
const _hoisted_48 = { class: "inputTitle" }
const _hoisted_49 = { class: "inputField flex-grow" }
const _hoisted_50 = { class: "inputTitle" }
const _hoisted_51 = { class: "inputField flex-grow" }
const _hoisted_52 = { class: "flex" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "text-center" }

import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import Error from "@/components/Error.vue";
import {DisdiMetadataType, DisdiStateType, ErrorLocationType} from "@/utilities/enums/Enums";
import {useGlobalStore} from "@/stores/GlobalStore";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {$t} from "@/utilities/i18n/config";
import {SettingService} from "@/utilities/services/entities/SettingService";
import {defaultSpaceAroundTableOnPage} from "@/AppConfig";
import {DisdiSetting} from "@/models/setting/disdi/DisdiSetting";
import {UserService} from "@/utilities/services/entities/UserService";
import {SelectableRoleInfo} from "@/models/SelectableRoleInfo";
import Tags from "@/components/inputs/Tags";
import Select from "@/components/inputs/Select";
import TextOrSpinner from "@/components/TextOrSpinner";
import {PermissionService} from "@/utilities/services/PermissionService";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import {LocationService} from "@/utilities/services/entities/LocationService";
import {LocationDisdiInfo} from "@/models/location/LocationDisdiInfo";
import { deepUnref } from 'vue-deepunref';
import { CategoryService } from "@/utilities/services/entities/CategoryService";



export default /*#__PURE__*/_defineComponent({
  __name: 'DisdiSettingsTab',
  setup(__props) {

const globalStore = useGlobalStore();
const categoryService = new CategoryService();
const settingService = new SettingService();
const userService = new UserService();
const permissionService = new PermissionService();
const locationService = new LocationService();

const categoryList = ref([]);
const settings = ref<DisdiSetting|null>(new DisdiSetting());
const editRolesList = ref<Array<SelectableRoleInfo>>([]);
const readRolesList = ref<Array<SelectableRoleInfo>>([]);

const selectedRead=ref([])
const selectedEdit=ref([])
const metaTimestampValues = Object.keys(DisdiMetadataType)
    .filter((x) => Number.isNaN(Number(x)))
    .map((type,i)=>({id:i, name:$t(`settings.disdiSettingsTab.metaTimestampType.${type}`)}))
const disdiValues = Object.keys(DisdiStateType)
    .filter((x) => Number.isNaN(Number(x)))
    .map((type,i)=>({id:i, name:$t(`settings.disdiSettingsTab.disdiType.${type}`)}))
const loadingConfirm = ref(false);
let oldDisdiValue = null as DisdiStateType|null;

const rules = computed(()=>{
  return {
    disdi: { required: helpers.withMessage($t('validators.required'), required), },
    metaTimestamp: { required: helpers.withMessage($t('validators.required'), required), },
  }
});
const validator = ref(useVuelidate(rules, settings));

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage-80}px`;
};

const updateReadList = (value:Array<SelectableRoleInfo>)=>{
  //@ts-expect-error
  settings.value.permissionRead = value;
}
const updateEditList = (value:Array<SelectableRoleInfo>)=>{
  //@ts-expect-error
  settings.value.permissionEdit = value;
}
const setMetaTimestampValue = (value:DisdiMetadataType)=>{
  //@ts-expect-error
  settings.value.metaTimestamp = value;
}
const setDefaultCategory = (value: string) => {
  //@ts-expect-error
  settings.value.defaultCategory = value;
}
const setDisdiValue = (value:DisdiStateType)=>{
  //@ts-expect-error
  settings.value.disdi = value;
}
const checkInputBounds = ({target}:any):number => {
  const min = +target.attributes["min"].value;
  const max = +target.attributes["max"].value;
  return target.valueAsNumber < min
      ? min
      : target.valueAsNumber > max
          ? max
          : target.valueAsNumber;
}

const updateDisdiSettings = async ()=>{
  loadingConfirm.value = true;

  if(settings.value === null) {
    loadingConfirm.value = false;
    return;
  }

  if(!(await validator.value.$validate())){
    loadingConfirm.value = false;
    return;
  }

  // save current values (SelectableRoleInfo)
  const convertedRead = settings.value.permissionRead;
  const convertedEdit = settings.value.permissionEdit;
  // convert to string array
  settings.value.permissionRead = settings.value.permissionRead.map(sr => sr.name);
  settings.value.permissionEdit = settings.value.permissionEdit.map(sr => sr.name);

  const success = await settingService.updateDisdiSetting(settings.value, ErrorLocationType.table);
  if(!success) {
    loadingConfirm.value = false;
    return;
  }

  if(oldDisdiValue !== settings.value.disdi && settings.value.disdi === DisdiStateType.AllLocations){
    const locations = await locationService.getLocations("display", ErrorLocationType.table)
    const newDisdiInfo = locations.map(l => new LocationDisdiInfo(l.id, true));
    await locationService.putSetLocationDisdiSettings(newDisdiInfo, ErrorLocationType.table);
  }

  const readRoleString = settings.value.permissionRead.join(", ");
  const editRoleString = settings.value.permissionEdit.join(", ");

  //TODO magic string? better idea?
  // update anabPolicy-Array with new permission values
  permissionService.updateDynamicPolicy("Disdi.Read", readRoleString);
  permissionService.updateDynamicPolicy("Disdi.LocationPropertyEdit", editRoleString);

  // convert array back to SelectableRoleInfo
  settings.value.permissionRead = convertedRead;
  settings.value.permissionEdit = convertedEdit;

  // avoid having the ref been carried over to the linked sidebar items
  // an with that this bug: sidebar changes even tough the settings werent saved yet
  globalStore.settings.disdiSettings = deepUnref(settings.value);

  loadingConfirm.value = false;

  globalStore.showSuccess($t("global.saved"));
}

const initSettings = async ()=>{
    categoryList.value = (await categoryService.getCategories("display", ErrorLocationType.popup))?.map((c) => {
        c.name = c.title;
        return c;
    });

  settings.value = await settingService.getDisdiSettings(ErrorLocationType.table);

  console.log(settings.value)

  const roles = await userService.getUserRoles(ErrorLocationType.table) ?? [];
  // flat copy role list to prevent shared options
  readRolesList.value = roles.map(el => ({...el}));
  editRolesList.value = roles.map(el => ({...el}));

  //@ts-expect-error
  selectedRead.value = settings.value.permissionRead
      .filter(p => p !== '')
      .map(p => roles.find(r => r.name === p));

  //@ts-expect-error
  selectedEdit.value = settings.value.permissionEdit
      .filter(p => p !== '')
      .map(p => roles.find(r => r.name === p));

  oldDisdiValue = settings.value.disdi;
}

const setRoleDropdowns = ()=>{
  let convertedArray = [];
  for (const r of settings.value.permissionRead){
    const convertedRole = readRolesList.value.find(cr => cr.name === r);
    convertedArray.push(convertedRole);

    const index = readRolesList.value.indexOf(convertedRole);
    readRolesList.value.splice(index, 1);
  }
  settings.value.permissionRead = convertedArray;

  convertedArray = [];
  for (const r of settings.value.permissionEdit){
    const convertedRole = editRolesList.value.find(cr => cr.name === r);
    convertedArray.push(convertedRole);

    const index = editRolesList.value.indexOf(convertedRole);
    editRolesList.value.splice(index, 1);
  }
  settings.value.permissionEdit = convertedArray;
}

onMounted(async () => {
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  globalStore.gridDataIsLoading = true;

  await initSettings();
  setRoleDropdowns();

  globalStore.gridDataIsLoading = false;
})

onBeforeUnmount(()=>{
  recalcGridHeight();
  window.removeEventListener('resize', recalcGridHeight);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).table
      }, null, 8, ["errorLoc"]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("h4", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref($t)('settings.disdiSettingsTab.generalDisdiSettings.title')) + " ", 1),
              _createElementVNode("span", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("b", null, _toDisplayString(_unref($t)('settings.disdiSettingsTab.generalDisdiSettings.titleInfo')), 1),
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_unref($t)('settings.disdiSettingsTab.generalDisdiSettings.titleDsecription')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref($t)('settings.disdiSettingsTab.generalDisdiSettings.disdi')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass({ error: validator.value.disdi.$errors.length })
                }, [
                  _createVNode(_unref(Select), {
                    options: _unref(disdiValues),
                    selected: settings.value.disdi,
                    onSelectChanged: setDisdiValue,
                    mode: "single"
                  }, null, 8, ["options", "selected"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validator.value.disdi.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "input-errors",
                      key: error.$uid
                    }, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ], 2)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($t)('settings.disdiSettingsTab.generalDisdiSettings.picturesAmount')), 1),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                min: "0",
                max: "10",
                step: "1",
                onInput: _cache[0] || (_cache[0] = ($event: any) => (settings.value.pictures = checkInputBounds($event))),
                class: "w-full",
                type: "number",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settings.value.pictures) = $event))
              }, null, 544), [
                [_vModelText, settings.value.pictures]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref($t)('settings.disdiSettingsTab.generalDisdiSettings.defaultCategory')), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_unref(Select), {
                options: categoryList.value,
                selected: settings.value.defaultCategory,
                onSelectChanged: setDefaultCategory,
                mode: "single"
              }, null, 8, ["options", "selected"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref($t)('settings.disdiSettingsTab.generalDisdiSettings.deleteDeadline')) + " " + _toDisplayString(_unref($t)('global.units.days')), 1),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                min: "0",
                max: "3650",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (settings.value.purgeOldDiaryEntriesIntervalDay = checkInputBounds($event))),
                step: "1",
                class: "w-full",
                type: "number",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((settings.value.purgeOldDiaryEntriesIntervalDay) = $event))
              }, null, 544), [
                [_vModelText, settings.value.purgeOldDiaryEntriesIntervalDay]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h4", _hoisted_16, [
              _createTextVNode(_toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiPermissionsSettings.title')) + " ", 1),
              _createElementVNode("span", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, [
                  _createElementVNode("b", null, _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiPermissionsSettings.titleInfo')), 1),
                  _hoisted_20,
                  _createTextVNode(" " + _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiPermissionsSettings.titleDesciption')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiPermissionsSettings.readRoles')), 1),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(Tags), {
                  selected: selectedRead.value,
                  options: readRolesList.value,
                  onSelectChanged: updateReadList
                }, null, 8, ["selected", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiPermissionsSettings.editRoles')), 1),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_unref(Tags), {
                selected: selectedEdit.value,
                options: editRolesList.value,
                onSelectChanged: updateEditList
              }, null, 8, ["selected", "options"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h4", _hoisted_25, [
              _createTextVNode(_toDisplayString(_unref($t)('settings.disdiSettingsTab.metadataSettings.title')) + " ", 1),
              _createElementVNode("span", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("span", _hoisted_28, [
                  _createElementVNode("b", null, _toDisplayString(_unref($t)('settings.disdiSettingsTab.metadataSettings.titleInfo')), 1),
                  _hoisted_29,
                  _createTextVNode(" " + _toDisplayString(_unref($t)('settings.disdiSettingsTab.metadataSettings.titleDescription')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref($t)('settings.disdiSettingsTab.metadataSettings.metaEditor')), 1),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((settings.value.metaEditor) = $event)),
                  name: "metaEditor"
                }, null, 512), [
                  [_vModelCheckbox, settings.value.metaEditor]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref($t)('settings.disdiSettingsTab.metadataSettings.metaTimestamp')), 1),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                class: _normalizeClass({ error: validator.value.metaTimestamp.$errors.length })
              }, [
                _createVNode(_unref(Select), {
                  options: _unref(metaTimestampValues),
                  selected: settings.value.metaTimestamp,
                  onSelectChanged: setMetaTimestampValue,
                  mode: "single"
                }, null, 8, ["options", "selected"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validator.value.metaTimestamp.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ], 2)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_35, _toDisplayString(_unref($t)('settings.disdiSettingsTab.metadataSettings.metaInvisibleTime')) + " " + _toDisplayString(_unref($t)('global.units.days')), 1),
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                min: "0",
                max: "3650",
                step: "1",
                onInput: _cache[5] || (_cache[5] = ($event: any) => (settings.value.metaInvisibleTime = checkInputBounds($event))),
                class: "w-full",
                type: "number",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((settings.value.metaInvisibleTime) = $event))
              }, null, 544), [
                [_vModelText, settings.value.metaInvisibleTime]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_unref($t)('settings.disdiSettingsTab.metadataSettings.metaInvisible')) + " " + _toDisplayString(_unref($t)('global.units.days')), 1),
            _createElementVNode("div", _hoisted_38, [
              _withDirectives(_createElementVNode("input", {
                min: "0",
                max: "3650",
                step: "1",
                onInput: _cache[7] || (_cache[7] = ($event: any) => (settings.value.metaInvisible = checkInputBounds($event))),
                class: "w-full",
                type: "number",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((settings.value.metaInvisible) = $event))
              }, null, 544), [
                [_vModelText, settings.value.metaInvisible]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_39, _toDisplayString(_unref($t)('settings.disdiSettingsTab.metadataSettings.metaDeleteAll')) + " " + _toDisplayString(_unref($t)('global.units.days')), 1),
            _createElementVNode("div", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                min: "0",
                max: "3650",
                step: "1",
                onInput: _cache[9] || (_cache[9] = ($event: any) => (settings.value.metaDeleteAll = checkInputBounds($event))),
                class: "w-full",
                type: "number",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((settings.value.metaDeleteAll) = $event))
              }, null, 544), [
                [_vModelText, settings.value.metaDeleteAll]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h4", _hoisted_41, [
              _createTextVNode(_toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiAppSettings.title')) + " ", 1),
              _createElementVNode("span", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("span", _hoisted_44, [
                  _createElementVNode("b", null, _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiAppSettings.titleInfo')), 1),
                  _hoisted_45,
                  _createTextVNode(" " + _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiAppSettings.titleDescription')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_46, _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiAppSettings.useGalleryInApp')), 1),
              _createElementVNode("div", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((settings.value.useGallery) = $event)),
                  name: "useGallery"
                }, null, 512), [
                  [_vModelCheckbox, settings.value.useGallery]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_48, _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiAppSettings.showInAppNr')), 1),
            _createElementVNode("div", _hoisted_49, [
              _withDirectives(_createElementVNode("input", {
                min: "0",
                max: "50",
                step: "1",
                onInput: _cache[12] || (_cache[12] = ($event: any) => (settings.value.showInAppNr = checkInputBounds($event))),
                class: "w-full",
                type: "number",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((settings.value.showInAppNr) = $event))
              }, null, 544), [
                [_vModelText, settings.value.showInAppNr]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_50, _toDisplayString(_unref($t)('settings.disdiSettingsTab.disdiAppSettings.showInAppDays')) + " " + _toDisplayString(_unref($t)('global.units.days')), 1),
            _createElementVNode("div", _hoisted_51, [
              _withDirectives(_createElementVNode("input", {
                min: "0",
                max: "3650",
                onInput: _cache[14] || (_cache[14] = ($event: any) => (settings.value.showInAppDays = checkInputBounds($event))),
                step: "1",
                class: "w-full",
                type: "number",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((settings.value.showInAppDays) = $event))
              }, null, 544), [
                [_vModelText, settings.value.showInAppDays]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("button", {
              disabled: loadingConfirm.value,
              class: "primary ml-auto",
              onClick: updateDisdiSettings
            }, [
              _createVNode(_unref(TextOrSpinner), {
                text: _unref($t)('global.save'),
                spin: loadingConfirm.value
              }, null, 8, ["text", "spin"])
            ], 8, _hoisted_53)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_unref(globalStore).gridDataIsLoading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_54, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, _unref(globalStore).gridDataIsLoading]
    ])
  ], 64))
}
}

})